import { motion } from "framer-motion";
import { State } from "../state/reducer";
import { Dispatch, useCallback } from "react";
import Action from "../state/actions";
import {
  getActiveInstrument,
  getInstrument,
  getInstrumentsAvailable,
  isReportCardMode,
} from "../state/selectors";
import ChannelReportCardStrip from "../molecules/Channels/ChannelReportCardStrip";
import ChannelStrip from "../molecules/Channels/ChannelStrip";
import MobileFailControlBar from "../molecules/MobileFailControlBar";

interface Props {
  state: State;
  dispatch: Dispatch<Action>;
  back: () => void;
}

export default function MultiMixModeScreen({ state, dispatch, back }: Props) {
  const reportCardMode = isReportCardMode(state);
  const afterSelectedCallback = useCallback(() => {
    back();
    scrollTo(0, 0);
  }, [back]);

  return (
    <>
      {reportCardMode && (
        <div className={"md:hidden"}>
          <MobileFailControlBar />
        </div>
      )}

      <motion.ul>
        {getInstrumentsAvailable(state).map((instrument, i) => (
          <motion.li key={i} className="mb-4">
            {reportCardMode ? (
              <ChannelReportCardStrip
                active={null}
                instrument={getInstrument(state, instrument)}
                state={state}
                dispatch={dispatch}
                afterSelectedCallback={afterSelectedCallback}
              />
            ) : (
              <ChannelStrip
                active={getActiveInstrument(state).instrument === instrument}
                instrument={getInstrument(state, instrument)}
                state={state}
                dispatch={dispatch}
                afterSelectedCallback={afterSelectedCallback}
              />
            )}
          </motion.li>
        ))}
      </motion.ul>
    </>
  );
}
